import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ccc4a840"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-0 px-0" }
const _hoisted_2 = { class: "select is-fullwidth is-small mx-0" }
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "mx-0 px-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mx-0 px-0" }, "-")
], -1))
const _hoisted_5 = { class: "mx-0 px-0" }
const _hoisted_6 = { class: "select is-fullwidth is-small mx-0" }
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-minus" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]


import { defineComponent, defineProps, ref, watch, defineEmits} from 'vue'
import { useStore } from "vuex";
import { Notyf } from "notyf";
import { useI18n } from 'vue-i18n';

const notyf = new Notyf()

const __default__ = defineComponent({
  name: "WorkingIntervalTableRow",
})


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: ['intervalData', 'extractDateFromDayOfWeek'],
  emits: ['changes-made'],
  setup(__props, { emit: __emit }) {


const props = __props
const store = useStore()
const { intervalData } = props
const { t } = useI18n();

const editedStart = ref(intervalData.start)
const editedEnd = ref(intervalData.end)

const emit = __emit

/* Old version. Several profiles
const removeWorkingInterval = ($t : any) => {

  if (confirm($t && $t('Vet.ConfirmAvailIntervalDelete'))) {
    //TODO:Create notification to ask if it is really to delete
    var editedDaySchedules: any
    console.log("remove")
    console.log(intervalData)
    editedDaySchedules = store.getters.getEditedDaySchedules
    console.log(editedDaySchedules)
    editedDaySchedules.forEach((daySchedule: any) => {
      if (daySchedule.dayOfWeek == intervalData.dayOfWeek) {
        daySchedule.workingIntervals.splice(intervalData.pos, 1)
      }
    })
    try {
      // Update day schedules
      store.dispatch('updateEditedDaySchedules', editedDaySchedules)
      console.log(store.getters.getEditedDaySchedules)
      notyf.success($t('Vet.NotyfAvailIntervalRemoved'))
      emit('changes-made', true) // Emit event indicating changes were made
    } catch (e) {
      notyf.error($t('Vet.NotyfErrorRemoveAvailInterval'))
    }
  }
}
*/

// New version. Unique profile

const removeWorkingInterval = () =>
{

  if (confirm(t('Vet.ConfirmAvailIntervalDelete')))
  {
    
    console.log("remove")
    console.log(intervalData)
    
    const availabilityIntervals = store.getters.getAvailabilityIntervals;
    console.log("Availability Intervals:", availabilityIntervals);
        
    const dayDateStr = props.extractDateFromDayOfWeek(intervalData.dayOfWeek);

    var editedDaySchedules = availabilityIntervals.filter((interval: any) => interval.dateStartInclusive == dayDateStr ).slice();
        
    console.log("Filtered Day Schedules:", editedDaySchedules);

    const daySchedule = editedDaySchedules[0];
        
    console.log("Day Schedule:", daySchedule);
    
    // remove position intervalDate.pos in daySchedule.hours

    daySchedule.hours.splice(intervalData.pos, 1);

    try
    {
      // Update day schedules
      store.dispatch('updateEditedDaySchedules', editedDaySchedules)
      console.log(store.getters.getEditedDaySchedules)
      notyf.success(t('Vet.NotyfAvailIntervalRemoved'))
      emit('changes-made', true) // Emit event indicating changes were made
    } catch (e) {
      notyf.error(t('Vet.NotyfErrorRemoveAvailInterval'))
    }
  }
}

watch(() => props.intervalData, (newValue) => {
  editedStart.value = newValue.start
  editedEnd.value = newValue.end
})

const updateWorkingInterval = () => {

  console.log("Updating interval data:", intervalData);
  
  const availabilityIntervals = store.getters.getAvailabilityIntervals;
  
  console.log("Availability Intervals:", availabilityIntervals);
      
  const dayDateStr = props.extractDateFromDayOfWeek(intervalData.dayOfWeek);

  var editedDaySchedules = availabilityIntervals.filter((interval: any) => interval.dateStartInclusive == dayDateStr ).slice();
      
  if (!editedDaySchedules.length)
  {
    console.log("No Day Schedule:");
    return;
  }
  
  console.log("Filtered Day Schedules:", editedDaySchedules);

  const daySchedule = editedDaySchedules[0];
      
  console.log("Day Schedule:", daySchedule);

  if (!daySchedule.hours) {
    console.log("Invalid Day Schedule!");
    return;
  }

  // update position intervalDate.pos in daySchedule.hours
  
  const intervalIndex = intervalData.pos

  if (intervalIndex !== -1)
  {
    const interval = daySchedule.hours[intervalIndex];
    //update only if values are different from the previous ones. this avoids flagging unnecessary changes
    if (editedStart.value === interval.start.slice(0,5) && editedEnd.value === interval.end.slice(0,5))
    {
      //console.log("No changes in interval data!");
      return;
    }

    console.log("Interval:", interval);
    if (editedEnd.value > editedStart.value)
    {
      daySchedule.hours =
      [
        ...daySchedule.hours.slice(0, intervalIndex),
        { ...interval, start: editedStart.value, end: editedEnd.value },
        ...daySchedule.hours.slice(intervalIndex + 1)
      ];
    }
    else {
      notyf.error(t('Vet.NotyfErrorStartEndAvailInterval'))
      editedStart.value = interval.start;
      editedEnd.value = interval.end;
    }
  }
  else
  {
    console.log("Interval not found!");
    return;
  }

  try {
    // Update day schedules
    store.dispatch('updateEditedDaySchedules', editedDaySchedules)
    console.log("Updated schedules in store:", store.getters.getEditedDaySchedules);
    //Deactivated because it generates too many messages when deleting intervals
    //notyf.success(t('Vet.NotyfAvailIntervalEdited'))
    emit('changes-made', true) // Emit event indicating changes were made
  } catch (e) {
    notyf.error(t('Vet.NotyfErrorEditAvailInterval'))
  }
}

watch(editedStart, updateWorkingInterval)
watch(editedEnd, updateWorkingInterval)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("td", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editedStart).value = $event)),
          type: "time",
          style: {"width":"70px"},
          required: ""
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters.getTimeLimits, (timeLim) => {
            return (_openBlock(), _createElementBlock("option", {
              key: timeLim.time_limit_id,
              value: timeLim.time_limit
            }, _toDisplayString(timeLim.time_limit), 9, _hoisted_3))
          }), 128))
        ], 512), [
          [_vModelSelect, editedStart.value]
        ])
      ])
    ]),
    _hoisted_4,
    _createElementVNode("td", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editedEnd).value = $event)),
          type: "time",
          style: {"width":"70px"},
          required: ""
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters.getTimeLimits, (timeLim) => {
            return (_openBlock(), _createElementBlock("option", {
              key: timeLim.time_limit_id,
              value: timeLim.time_limit
            }, _toDisplayString(timeLim.time_limit), 9, _hoisted_7))
          }), 128))
        ], 512), [
          [_vModelSelect, editedEnd.value]
        ])
      ])
    ]),
    _createElementVNode("td", { class: "mx-0 px-0" }, [
      _createElementVNode("div", { class: "is-flex is-justify-content-start mx-0" }, [
        _createElementVNode("button", {
          type: "button",
          class: "button is-primary is-light is-small is-rounded",
          onClick: removeWorkingInterval
        }, _hoisted_9)
      ])
    ])
  ], 64))
}
}

})